import { CustomModal } from '@/components/CustomModal';
import UserRegistrationPage from '@/pages/UserRegistration/UserRegistrationPage';
import { getLoggedInUser } from '@/store/account/selector';
import { useAppSelector } from '@/store/hooks/useAppSelector';

interface InboundAgentCreationModalProps {
	isOpen?: boolean;
	onClose?: () => void;
	setShowCreateAgent: React.Dispatch<React.SetStateAction<boolean>>;
	refetch: () => void;
}

const InboundAgentCreationModal = ({
	isOpen,
	onClose,
	setShowCreateAgent,
	refetch,
}: InboundAgentCreationModalProps) => {
	const loggedInUser = useAppSelector(getLoggedInUser);

	return (
		<CustomModal
			title="Create New Inbound Agent"
			isModalOpen={isOpen}
			cancelAction={onClose}
			footer={null}
			width={1200}
		>
			{isOpen && (
				<>
					<UserRegistrationPage
						trialForReseller={false}
						handleComplete={() => {
							refetch();
							setShowCreateAgent(false);
						}}
						userId={loggedInUser?.id}
						agentType="Inbound"
					/>
					<div className="help-section mb-5">
						<p>
							Need help? <a href="#">Contact our support team</a>
						</p>
					</div>
				</>
			)}
		</CustomModal>
	);
};

export default InboundAgentCreationModal;
